const AppSettings = {
    //LocalRobotWSUrl: "ws://192.168.46.111:9090",
    //RobotWSUrl: "wss://robotsim.deliversai.net:9443",
    RobotWSUrl: "wss://robot1.delivers.ai:9443",
    // ServiceUrl: "https://localhost:5001/api",
    ServiceUrl: "https://fmapi.delivers.ai/api",
    //CameraLeftUrl:"http://robot1.delivers.ai:8080/stream?topic=/camera_mid/color/image_raw&type=mjpeg&quality=20",
    CameraLeftUrl: "http://robot1.delivers.ai:8080/stream?topic=/camera_left/color/image_raw&type=mjpeg&quality=5",
    CameraRightUrl: "http://robot1.delivers.ai:8080/stream?topic=/camera_right/color/image_raw&type=mjpeg&quality=5",
    CameraMidUrl: "http://robot1.delivers.ai:8080/stream?topic=/camera_mid/color/image_raw&type=mjpeg&quality=5",
    NotifierLimit: 3,
    RobotNotifierLimit: 1,
    //SignalRUrl: "https://localhost:5001/clienthub",
    SignalRUrl: "https://fmapi.delivers.ai/clienthub",
    RobotTrackLink: "delivers.ai/#/purchaser?orderkey=26374937&access=jr84p23s129-21kf3",
    RobotMaxLinear: 1.2, // m/s
    RobotMaxAngular: 0.8, // rad/s
    Precision: 8
}


// const AppSettings={
//     //RobotWSUrl:"wss://35.172.136.105:9443",
//     RobotWSUrl:"wss://localhost:9090",
//     ServiceUrl:"https://fmapi.delivers.ai/api",
//     CameraLeftUrl:"http://localhost:8080/stream?topic=/camera_left/camera_left/image_raw&type=mjpeg&quality=20",
//     CameraRightUrl:"http://localhost:8080/stream?topic=/camera_right/camera_right/image_raw&type=mjpeg&quality=20",
//     CameraMidUrl:"http://localhost:8080/stream?topic=/camera_mid/camera_mid/image_raw&type=mjpeg&quality=20",
//     NotifierLimit:3,
//     SignalRUrl:"https://fmapi.delivers.ai/clienthub",
//     RobotTrackLink:"https://manager.delivers.ai/#/purchaser?orderkey=26374937&access=jr84p23s129-21kf3"
// }



export default AppSettings;